import InactivityTimeoutWorker from '@/branchmanager/app/worker/inactivityTimeoutWorker.ts?sharedworker';

const inactivityTimeoutWorker = new InactivityTimeoutWorker();
const port = inactivityTimeoutWorker.port;

port.start();

export default port;
